import { useState } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const useProgressiveBar = ({initialValue, maxValue,w, h,colorBar, label, url }) => {

    const styles = {
        container: {
            width: w?w:200,
            height: h?h:200,
        },
        circular:{
            path: {
                stroke: colorBar ?colorBar:'#f7b733',
                strokeLinecap: 'butt',
                transition: 'stroke-dashoffset 0.5s ease 0s',
            },
            text: {
                fill: colorBar ?colorBar:'#f7b733',
                fontSize: '14px',
            },
        },
        subtitle:{
            fontSize: 14,
            marginTop: -5,
            color: colorBar?colorBar:'#f7b733'
        },
        title:{
            color: colorBar?colorBar:'#f7b733'
        }
    }
    const [value, setValue] = useState(initialValue? initialValue : 0);

    const Progress = (
        <div style={styles.container}>
            <CircularProgressbarWithChildren
                value={value? value : initialValue}
                maxValue={maxValue?maxValue:1}
                styles={styles.circular}>

                <h6 style={styles.title}>{value? value : initialValue}</h6>
                <div style={styles.subtitle}>
                    <strong>{`${label ? label : ""}`}</strong>
                </div>
            </CircularProgressbarWithChildren>
        </div>
    )
    return {
        get: value,
        circular: Progress,
        set: setValue
    }

}
export default useProgressiveBar;